import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Ocho = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Cost Structure</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>The Financial Data Analytics that we made show that our test  has a <b>price of $49 USD.</b><br/><br/>With a lifetime value of 2 years our cost to <b>acquire more customers would be $852.00 USD</b> taking into consideration the brand creation, promotional campaigns, video production, events and  agencies.<br/><br/>Also the cost to <b>manufacture would be $3162.20 USD</b> and finally the whole <b>development of the product would cost $6021.22 USD.</b></Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-31-png.png'/>
          <p><b>Fig. 6.8</b>  Complementary image of the <q>Cost Structure</q> section in the Business Model Canva </p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Ocho;
